import React from "react"
import { PrimeIcons } from "primereact/api"
import { Panel } from "primereact/panel"
import { useHistory, useParams } from "react-router-dom"

import { TawreedAction, TawreedActionName } from "../../../../../common/actions"
import { TawreedForm, TawreedFormField, TawreedFormMode, TawreedFormSubmitAction, TawreedFormSubmitCallback, TawreedFormSubmitProps, TawreedInputFile, TawreedInputNumber, TawreedInputSwitch, TawreedInputText, TawreedInputTextarea, TawreedMenuDropdown, TawreedNavLink } from "../../../../../common/components"
import { tawreedTranslationService } from "../../../../../common/translations"
import { Routes } from "../../../../../router"
import { StatesDropdown } from "../../../../states"
import { PaymentPartner, PaymentPartnerService } from "../../../domain"
import { AccountAutoCompleteComponent } from "../../../../finance/presentaion/components"

export const PaymentPartnerForm: React.FC = () => {

    const { id } = useParams<{ id: string | undefined }>();
    const history = useHistory();
    const service: PaymentPartnerService = React.useMemo(() => new PaymentPartnerService(), []);

    const [loading, setLoading] = React.useState<boolean>(false);
    const [mode, setMode] = React.useState<TawreedFormMode>('Create');
    const [data, setData] = React.useState<PaymentPartner>({
        active: true,
        otpLength: 4
    });
    const [actions, setActions] = React.useState<TawreedAction[]>([]);

    React.useEffect(() => {
        let mounted = true;
        if (id) {
            if (mounted) {
                setMode('Edit');
                setLoading(true);
            }
            service.getDetails(Number.parseInt(id))
                .then(res => {
                    console.log(res);

                    if (mounted) {
                        setLoading(false);
                        setData(res);
                    }
                })
                .catch(() => {
                    if (mounted) {
                        setLoading(false);
                    }
                })
        } else {
            if (mounted) {
                setMode('Create');
                setData({});
            }
        }
        return () => {
            mounted = false;
        };
    }, [id, service]);


    const onCreateOrSave = (data: PaymentPartner, cb: TawreedFormSubmitCallback<PaymentPartner>): Promise<void> => {
        setLoading(true);
        return service.createOrUpdate(data)
            .then((res) => {
                if (mode === 'Create') {
                    history.replace(Routes.PaymentPartnersDetails.replace(':id', res.paymentPartnerId ? res.paymentPartnerId.toString() : "0"));
                }
                setLoading(false);
                setData(res);
                cb(res);
            })
            .catch(err => {
                setLoading(false);
                cb(err);
            });
    }

    const onSubmit: TawreedFormSubmitProps<PaymentPartner> = {
        showButton: true,
        resetOnSubmit: false,
        onSubmit: new TawreedFormSubmitAction<PaymentPartner>(TawreedActionName.PaymentPartnersSubmit, 'lbl_save', PrimeIcons.SAVE, onCreateOrSave),
    };

    React.useEffect(
        () => {
            const onDelete = () => {
                setLoading(true);
                return service.delete(data!.paymentPartnerId!).then(res => {
                    setLoading(false);
                    history.replace(Routes.PaymentPartnersSearch);
                }).catch(err => {
                    setLoading(false);
                    throw err;
                });
            }

            const onDeactivate = () => {
                return service.deactivateAll([data!.paymentPartnerId!]).then(res => {
                    setLoading(false);
                    if (res) {
                        setData({ ...data, active: false })
                    }
                }).catch(err => {
                    setLoading(false);
                    throw err;
                });
            }
            const onActivate = () => {
                return service.activateAll([data!.paymentPartnerId!]).then(res => {
                    setLoading(false);
                    if (res) {
                        setData({ ...data, active: true })
                    }
                }).catch(err => {
                    setLoading(false);
                    throw err;
                });
            }

            const next = [
            ];
            if (data && data.partnerName) {
                next.push(new TawreedAction(TawreedActionName.PaymentPartnersDelete, 'statefull', 'lbl_delete', PrimeIcons.TRASH, onDelete, 'p-button-danger', true));
                if (!data.active) {
                    next.push(
                        new TawreedAction(TawreedActionName.PaymentPartnersActivate, 'statefull', (e) => tawreedTranslationService.translate('lbl_activate'), PrimeIcons.CHECK, onActivate, 'p-button-primary', 'confirm')
                    );
                }
                else {
                    next.push(
                        new TawreedAction(TawreedActionName.PaymentPartnersDeactivate, 'statefull', (e) => tawreedTranslationService.translate('lbl_deactivate'), PrimeIcons.CHECK, onDeactivate, 'p-button-primary', 'confirm')
                    );
                }
            }
            setActions(next);
        },
        [data, service, history]);


    return (
        <TawreedForm title="lbl_payment_partners"
            dataKey="paymentPartnerId" data={data}
            submit={onSubmit}
            loading={loading} mode={mode}
            actions={actions} useBack=".." useReset={false} className="grid form-grid">

            <Panel header={tawreedTranslationService.translate('lbl_general_information')} className="col-12">
                <div className="grid">
                    <div className="col-12">
                        <div className="grid">
                            <TawreedFormField name="logoContent" className="field col-12 md:col-3" title="lbl_partners_logo">
                                <TawreedInputFile render="form" name="logoContent" accept="image" />
                            </TawreedFormField>
                        </div>
                    </div>

                    {
                        id &&
                        <React.Fragment>
                            <TawreedFormField name="partnerId" className="field col-12 md:col-6" title="lbl_partners_partnerid">
                                <TawreedInputText name="partnerId" render="form" rules={{ required: 'msg_field_is_required' }} disabled />
                            </TawreedFormField>
                            <TawreedFormField name="paymentPartnerUniqueId" className="field col-12 md:col-6" title="lbl_partners_uniqueid">
                                <TawreedInputText name="paymentPartnerUniqueId" render="form" rules={{ required: 'msg_field_is_required' }} disabled />
                            </TawreedFormField>
                            {/* <TawreedFormField name="balanceId" className="field col-12 md:col-6" title="lbl_partners_balanceid">
                                <TawreedInputText name="balanceId" render="form" rules={{ required: 'msg_field_is_required' }} disabled />
                            </TawreedFormField> */}
                        </React.Fragment>
                    }

                    {/* <TawreedFormField name="businessType" className="field col-12 md:col-6" title="lbl_partners_business_type">
                        <PartnerBusinessTypeDropdown disabled={id ? true : false} partnerType={PartnerType.TopUp} name="businessType" render="form" rules={{ required: 'msg_field_is_required' }} />
                    </TawreedFormField> */}
                    <TawreedFormField name="partnerName" className="field col-12 md:col-6" title="lbl_partners_partner_name">
                        <TawreedInputText name="partnerName" render="form" rules={{ required: 'msg_field_is_required' }} />
                    </TawreedFormField>
                    <TawreedFormField name="active" title="lbl_payment_partner_active" className="field-checkbox col-12 md:col-6" flip>
                        <TawreedInputSwitch name="active" render="form" />
                    </TawreedFormField>
                    <TawreedFormField name="paymentPartnerTitleAr" className="field col-12 md:col-6" title="lbl_partners_partner_title_ar">
                        <TawreedInputText name="paymentPartnerTitleAr" render="form" rules={{ required: 'msg_field_is_required' }} />
                    </TawreedFormField>
                    <TawreedFormField name="paymentPartnerTitleEn" className="field col-12 md:col-6" title="lbl_partners_partner_title_en">
                        <TawreedInputText name="paymentPartnerTitleEn" render="form" rules={{ required: 'msg_field_is_required' }} />
                    </TawreedFormField>

                    <TawreedFormField className="field col-6 md:col-6" name="otpLength" title="lbl_payment_partners_otpLength">
                        <TawreedInputNumber render="form" name="otpLength" rules={{ required: 'msg_field_is_required', max: 100, min: 0 }} />
                    </TawreedFormField>

                    <TawreedFormField className="field col-12 md:col-6" name="infoUrl" title="lbl_payment_partners_infoUrl">
                        <TawreedInputText render="form" name="infoUrl" />
                    </TawreedFormField>
                </div>
            </Panel>

            <Panel header={tawreedTranslationService.translate('lbl_partners_address_information')} className="col-12">
                <div className="grid">
                    {/* <TawreedFormField name="address.zoneId" className="field col-12 md:col-12" title="lbl_partners_address_zone">
                        <ZonesDropdown name="address.zoneId" rules={{ required: 'msg_field_is_required' }} render="form" state={{ render: 'form', name: 'address.stateId' }} />
                    </TawreedFormField> */}
                    <TawreedFormField name="address.stateId" className="field col-12 md:col-12" title="lbl_partners_address_state_id">
                        <StatesDropdown name="address.stateId" rules={{ required: 'msg_field_is_required' }} render="form" />
                    </TawreedFormField>
                    <TawreedFormField name="address.street" className="field col-12" title="lbl_partners_address_street">
                        <TawreedInputText name="address.street" rules={{ required: 'msg_field_is_required' }} render="form" />
                    </TawreedFormField>

                </div>
            </Panel>

            <Panel header={tawreedTranslationService.translate('lbl_payment_partners_payment_information')} className="col-12">
                <div className="grid">

                    <TawreedFormField className="field col-6 md:col-6" name="transferCost" title="lbl_payment_partners_transferCost">
                        <TawreedInputNumber render="form" name="transferCost" mode="decimal" rules={{ required: 'msg_field_is_required' }} />
                    </TawreedFormField>
                    <TawreedFormField className="field col-6 md:col-6" name="transferSelling" title="lbl_payment_partners_transferSelling">
                        <TawreedInputNumber render="form" name="transferSelling" mode="decimal" rules={{ required: 'msg_field_is_required' }} />
                    </TawreedFormField>

                    <TawreedFormField className="field col-6 md:col-6" name="cashbackPercentage" title="lbl_payment_partners_cashbackPercentage">
                        <TawreedInputNumber render="form" name="cashbackPercentage" rules={{ required: 'msg_field_is_required', max: 100, min: 0 }} />
                    </TawreedFormField>

                    
                    <TawreedFormField name="transferAccountId" title="lbl_payment_partners_account" className="field col-12 md:col-6">
                        <AccountAutoCompleteComponent accountType={14} autoCompleteName="transferAccountId"
                        autoCompleteField="accountTitle" autoCompleteRender="form" autoCompleteRules={{ required: 'msg_field_is_required' }} />
                    </TawreedFormField>

                    <TawreedFormField name="transferOnDeliver" title="lbl_payment_partners_transferOnDeliver" className="field-checkbox col-12 md:col-6" flip>
                        <TawreedInputSwitch name="transferOnDeliver" render="form" />
                    </TawreedFormField>

                    <TawreedFormField name="paySellerOnDeliver" title="lbl_payment_partners_paySellerOnDeliver" className="field-checkbox col-12 md:col-6" flip>
                        <TawreedInputSwitch name="paySellerOnDeliver" render="form" />
                    </TawreedFormField>
                    <TawreedFormField name="requiredOtpOnRelease" title="lbl_payment_partners_requiredOtpOnRelease" className="field-checkbox col-12 md:col-6" flip>
                        <TawreedInputSwitch name="requiredOtpOnRelease" render="form" />
                    </TawreedFormField>
                </div>
            </Panel>
        </TawreedForm>
    )
}
